/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1NotificationMobileApp202,
  PostApiV1NotificationMobileApp400,
  PostApiV1NotificationMobileApp401,
  PostApiV1NotificationMobileApp500,
  PostApiV1NotificationMobileAppMutationRequest,
  PostApiV1NotificationMobileAppMutationResponse,
} from "../../types/notificationMobileAppController/PostApiV1NotificationMobileApp.ts";
import { createMobileNotificationRequestViewModelSchema } from "../createMobileNotificationRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1NotificationMobileApp202Schema =
  z.any() as unknown as ToZod<PostApiV1NotificationMobileApp202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1NotificationMobileApp400Schema =
  z.any() as unknown as ToZod<PostApiV1NotificationMobileApp400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1NotificationMobileApp401Schema =
  z.any() as unknown as ToZod<PostApiV1NotificationMobileApp401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1NotificationMobileApp500Schema =
  z.any() as unknown as ToZod<PostApiV1NotificationMobileApp500>;

export const postApiV1NotificationMobileAppMutationRequestSchema = z.lazy(
  () => createMobileNotificationRequestViewModelSchema,
) as unknown as ToZod<PostApiV1NotificationMobileAppMutationRequest>;

export const postApiV1NotificationMobileAppMutationResponseSchema = z.lazy(
  () => postApiV1NotificationMobileApp202Schema,
) as unknown as ToZod<PostApiV1NotificationMobileAppMutationResponse>;
